import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=a9877852&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=a9877852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9877852",
  null
  
)

export default component.exports